import { hasExternalReferrer } from './hasExternalReferrer';

const REGEXP = /(?:www\.)?([a-z0-9\-.]+)(?:\.[a-z.]+[/]?).*/;

export const getTld = (url = '') => {
  const tld = hasExternalReferrer(url) ? REGEXP.exec(url) || [] : [];

  return tld[1] || '';
};
